export const trackingRepeatUser = {
    event: "repeat_user_identified",
    eventCategory: "repeat_user_identified",
    eventAction: "repeat_appt"
};
